import PaiementsController from './paiements.controller';

export default {
    template: require('./paiements.tpl.html'),
    controller: PaiementsController
};
